import consultationSigninSignin from './questions/consultationSigninSignin';
import consultationWelcome from './questions/consultationWelcome';
import myGoalsGoals from './questions/myGoalsGoals';
import myHairAge from './questions/myHairAge';
import myHairDandruffLevel from './questions/myHairDandruffLevel';
import myHairDensity from './questions/myHairDensity';
import myHairGeneticHairLoss from './questions/myHairGeneticHairLoss';
import myHairGray from './questions/myHairGray';
import myHairHairloss from './questions/myHairHairloss';
import myHairLength from './questions/myHairLength';
import myHairOil from './questions/myHairOil';
import myHairPorosity from './questions/myHairPorosity';
import myHairSensitivity from './questions/myHairSensitivity';
import myHairShampooFrequency from './questions/myHairShampooFrequency';
import myHairSplitEnds from './questions/myHairSplitEnds';
import myHairTexture from './questions/myHairTexture';
import myHairThickness from './questions/myHairThickness';
import myHairType from './questions/myHairType';
import myLifestyleDiet from './questions/myLifestyleDiet';
import myLifestyleGeoAggressors from './questions/myLifestyleGeoAggressors';
import myLifestyleHormones from './questions/myLifestyleHormones';
import myLifestyleHydration from './questions/myLifestyleHydration';
import myLifestyleOtherHairLossCauses from './questions/myLifestyleOtherHairLossCauses';
import myLifestyleSmokeExposure from './questions/myLifestyleSmokeExposure';
import myLifestyleSports from './questions/myLifestyleSports';
import myLifestyleStress from './questions/myLifestyleStress';
import myLifestyleTransitionScreen from './questions/myLifestyleTransitionScreen';
import myLifestyleZipcode from './questions/myLifestyleZipcode';
import myPreferencesExceptions from './questions/myPreferencesExceptions';
import myPreferencesFragrance from './questions/myPreferencesFragrance';
import myPreferencesTransitionScreen from './questions/myPreferencesTransitionScreen';
import myTreatmentsColorTreatments from './questions/myTreatmentsColorTreatments';
import myTreatmentsColorTreatmentsCadence from './questions/myTreatmentsColorTreatmentsCadence';
import myTreatmentsColorTreatmentsLocation from './questions/myTreatmentsColorTreatmentsLocation';
import myTreatmentsColorTreatmentsType from './questions/myTreatmentsColorTreatmentsType';
import myTreatmentsExtensionsTypes from './questions/myTreatmentsExtensionsTypes';
import myTreatmentsOtherTreatments from './questions/myTreatmentsOtherTreatments';
import myTreatmentsOtherTreatmentsCadence from './questions/myTreatmentsOtherTreatmentsCadence';
import myTreatmentsRoutine from './questions/myTreatmentsRoutine';
import myTreatmentsStyles from './questions/myTreatmentsStyles';
import myTreatmentsStylesCadence from './questions/myTreatmentsStylesCadence';
import myTreatmentsTransitionScreen from './questions/myTreatmentsTransitionScreen';

export default [
  consultationWelcome,
  consultationSigninSignin,
  // -----------------------------------------------------
  // HAIR AND SCALP
  myHairAge,
  myHairTexture,
  myHairLength,
  myHairType,
  myHairSplitEnds,
  myHairPorosity,
  myHairThickness,
  myHairDensity,
  myHairHairloss,
  myHairGeneticHairLoss,
  myHairShampooFrequency,
  myHairOil,
  myHairDandruffLevel,
  myHairSensitivity,
  myHairGray,
  // -----------------------------------------------------
  // TREATMENT AND STYLING
  myTreatmentsTransitionScreen,
  myTreatmentsColorTreatments,
  myTreatmentsColorTreatmentsLocation,
  myTreatmentsColorTreatmentsType,
  myTreatmentsColorTreatmentsCadence,
  myTreatmentsOtherTreatments,
  myTreatmentsOtherTreatmentsCadence,
  myTreatmentsStyles,
  myTreatmentsStylesCadence,
  myTreatmentsExtensionsTypes,
  myTreatmentsRoutine,
  // -----------------------------------------------------
  // LIFESTYLE AND ENVIRONMENT
  myLifestyleTransitionScreen,
  myLifestyleHormones,
  myLifestyleDiet,
  myLifestyleHydration,
  myLifestyleSmokeExposure,
  myLifestyleStress,
  myLifestyleOtherHairLossCauses,
  myLifestyleSports,
  myLifestyleZipcode,
  myLifestyleGeoAggressors,
  // -----------------------------------------------------
  // PREFERENCES AND FRAGRANCE
  myPreferencesTransitionScreen,
  myPreferencesExceptions,
  myPreferencesFragrance,
  // -----------------------------------------------------
  // HAIR GOALS
  myGoalsGoals,
];
